// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3bjn6","card":"Cards_card__eGUfZ","infected":"Cards_infected__-adYp","recovered":"Cards_recovered__1aizD","death":"Cards_death__207V6"};